import { usePriceLookup as useSharedPriceLookup } from '@/hooks/use-price-lookup';
import { DetailRow } from '../components/form-dialog/hooks/useDetailRows';
import { useHoaDonMuaHangTrongNuocSearchContext } from '../context';

interface PriceLookupResponse {
  gia_nt?: number;
  [key: string]: MuaHangRecord;
}
export function usePriceLookup(customerUUID?: string) {
  const { ngayCt: effectiveDate } = useHoaDonMuaHangTrongNuocSearchContext();

  return useSharedPriceLookup<DetailRow, PriceLookupResponse>({
    endpoint: '/erp/purchase-prices/price-lookup/',
    effectiveDate: effectiveDate,
    customerUuid: customerUUID,
    manualPriceFields: ['gia_nt0'],
    buildUpdates: ({ response, quantity }) => {
      const gia = Number(response?.gia_nt) || 0;
      const tien = gia * quantity;

      return {
        gia_nt0: gia,
        tien_tck_nt: tien,
        tien_nt0: tien
      };
    }
  });
}
